var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onTheGoList-container flex-column justify-content-start"},[_c('top-bar',{attrs:{"title":'随手拍历史发布'}}),_c('div',{staticClass:"onTheGoList-content"},[_c('waterfall')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }